import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import config from "../config";

export default function CheckLoginRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    const checkUserAuth = async () => {
      try {
        const res = await fetch(`${config.API_BASE_URL}/api/auth/profile`, {
          credentials: "include",
        });
        const data = await res.json();

        if (data && !data.error && data._id) {
          // ✅ User is logged in — redirect to dashboard
          navigate("/dashboard");
        }
      } catch (error) {
        console.error("Error checking login:", error);
      }
    };

    checkUserAuth();
  }, [navigate]);

  return null; // No UI — it just runs the redirect logic
}
